import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import {loadWorkspace} from "./workspaceSlice"
import axios from "axios"
import { fetchUniqueCountsForEachPath } from "./workspaceNoteSlice"
import { getImportedArticleCountForWorkspace } from "./freeTierTrackerslice"
import { removeArticleFromImportedExcludedList } from "./automatedSearchViewSlice"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

export const deleteArticle = createAsyncThunk(
	"deletedArticles/deleteArticle",
	async ({articleId, fromAutoSearch = false, articlePMID, workspaceId}, { rejectWithValue, dispatch}) => {

		if (!workspaceId) return rejectWithValue("Failed to fetch unique counts. Invalid WorkspaceId")
		try {
			const { data: article } = await axios.delete(`/api/workspace/${workspaceId}/article/${articleId}`)
			dispatch(fetchUniqueCountsForEachPath({paths: article.path, workspaceId}))
			dispatch(getImportedArticleCountForWorkspace({workspaceId}))
			if (fromAutoSearch) {
				dispatch(removeArticleFromImportedExcludedList({pmid: articlePMID, workspaceId}))
			}
			return {article, workspaceId}
		} catch (error) {
			return rejectWithValue(`Failed to delete article with ID ${articleId}`)
		}
	}
)

const initialState = {
	deletedArticles: [],
	deleteArticleError: null
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialState)
export const deletedArticlesSlice = createSlice({
	name: "deletedArticles",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		addDeletedArticle: (state, action) => {
			const {article, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.deletedArticles.push(article)
		},
		removeDeletedArticle: (state, action) => {
			const {articleId, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			const articleIndex = workspace.deletedArticles.findIndex(deletedArticle => deletedArticle.articleId === articleId)
			if(articleIndex >= 0) {
				workspace.deletedArticles.splice(articleIndex, 1)
			}
		},
		clearDeleteArticleError: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.deleteArticleError = null
		}

	},
	extraReducers: (builder) => {
		builder.addCase(deleteArticle.fulfilled, deletedArticlesSlice.caseReducers.addDeletedArticle)
		builder.addCase(deleteArticle.rejected, (state, action) => {
			const workspace = ensureWorkspace(state, action.meta.arg.workspaceId)
			workspace.deleteArticleError = "Failed to delete this article from all notes in workspace"
		})
		builder.addCase(loadWorkspace.fulfilled, (state, action) => {
			const workspaceId = action.payload.workspace.id
			ensureWorkspace(state, workspaceId)
		})
	}
})

export const {
	addDeletedArticle,
	removeDeletedArticle,
	clearDeleteArticleError
} = deletedArticlesSlice.actions

export const selectWorkspaceDeletedArticles = (state, workspaceId) => state.deletedArticles.byWorkspace[workspaceId]?.deletedArticles ?? initialState.deletedArticles
export const selectDeleteArticleError = (state, workspaceId) => state.deletedArticles.byWorkspace[workspaceId]?.deleteArticleError ?? initialState.deleteArticleError

export default deletedArticlesSlice.reducer